import { useEffect, useState } from "react";
import { motion } from "motion/react";
import "./LoadingScreen.css";

function LoadingScreen({ onComplete }) {
  const [isExiting, setIsExiting] = useState(false);
  const [shouldFill, setShouldFill] = useState(false);

  useEffect(() => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const fillDelay = window.setTimeout(() => setShouldFill(true), 40);
    const exitDelay = window.setTimeout(() => setIsExiting(true), reducedMotion ? 120 : 1050);
    const doneDelay = window.setTimeout(onComplete, reducedMotion ? 260 : 1360);

    return () => {
      window.clearTimeout(fillDelay);
      window.clearTimeout(exitDelay);
      window.clearTimeout(doneDelay);
    };
  }, [onComplete]);

  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 1, filter: "blur(0px)" }}
      animate={{
        opacity: isExiting ? 0 : 1,
        filter: isExiting ? "blur(10px)" : "blur(0px)",
      }}
      transition={{ duration: 0.28, ease: "easeInOut" }}
      aria-hidden="true"
    >
      <div className="loading-line" role="presentation">
        <span className={shouldFill ? "loading-line-fill is-filled" : "loading-line-fill"} />
      </div>
    </motion.div>
  );
}

export default LoadingScreen;
